import React from 'react'
import Thumbnail from '../Thumbnail';

class DescriptionThumbnail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      title: props.title,
      description: props.description || false,
      thumbnail: props.thumbnail,
      link: props.link,
    }
  }

  render() {
    const {title, description, thumbnail, link} = this.state;

    return (
      <div className="afd-caption-thumbnail">
        <div className="afd-caption-thumbnail__thumbnail">
          <Thumbnail src={thumbnail} link={link}/>
        </div>
        <div className="afd-caption-thumbnail__content">
          <a href={link} className="afd-caption-thumbnail__heading">{title}</a>
          {description &&
            <p className="afd-caption-thumbnail__description">{description}</p>
          }
        </div>
      </div>
    )
  }
}

export default DescriptionThumbnail;